import { useCallback } from 'react'

import { FixedBanner, TextLink } from '@circlefin/components'
import { custodyCircleWalletCurrency } from '@services/sections/lib/custody'
import { Currency } from '@shared/graphql'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import type { ResumeTransferBannerProps } from './ResumeTransferBanner'

export type ResumeTransferBannerMultipleProps = Pick<
  ResumeTransferBannerProps,
  'variant'
>

export const ResumeTransferBannerMultiple: React.FC<
  ResumeTransferBannerMultipleProps
> = ({ variant }) => {
  const { t } = useTranslation('ace')
  const { push } = useRouter()

  const resumeMultipleTransfers = useCallback(() => {
    void push({
      pathname: custodyCircleWalletCurrency.route,
      query: {
        currency: Currency.USDC,
      },
    })
  }, [push])

  return (
    <FixedBanner status="warning">
      <FixedBanner.Title>
        {t('resumeTransferBanner.multipleTransfers.title')}
      </FixedBanner.Title>

      {variant && (
        <FixedBanner.Description>
          {t(`resumeTransferBanner.multipleTransfers.description.${variant}`)}

          {/* Only show CTA when on the home page */}
          {variant === 'home' && (
            <TextLink
              onClick={resumeMultipleTransfers}
              size="sm"
              variant="primary"
            >
              {t('resumeTransferBanner.multipleTransfers.cta')}
            </TextLink>
          )}
        </FixedBanner.Description>
      )}
    </FixedBanner>
  )
}
